import configJson from "../auth_config.json";

export function resolveTenant(): string {
    const host = window.location.host;        // e.g. acme.tailvation.app:5173
    const [sub] = host.split('.');

    // Local dev fallbacks: http://localhost:5173/?tenant=localDevKey
    const urlTenant = new URLSearchParams(window.location.search).get('tenant');
    return (urlTenant || (sub && sub !== 'localhost:3000' ? sub : configJson.localDevKey)).toLowerCase();
}
